import { CarDealerData } from "@comparaonline/contact-form-schema";
import { useRouter } from "../../../../lib/routerContext";

interface Values {
  carDealerData: CarDealerData;
}

interface QueryParams extends Record<string, string> {
  carDealerName: string;
  carDealerAgentId: string;
  massive?: string;
}

const useFormValuesQueryParams = (): Partial<Values> => {
  const router = useRouter<QueryParams>();
  if (!router) {
    return {};
  }

  const query = router.query;
  if (!query) {
    return {};
  }

  let values = {};

  const { carDealerName, carDealerAgentId } = query;
  if (carDealerName) {
    const massive = query.massive != undefined;
    values = {
      ...values,
      carDealerData: { name: carDealerName, agentIdentificationNumber: carDealerAgentId, massive }
    };
  }

  return values;
};

export { useFormValuesQueryParams };
